export const fonts = {
  heading: 'Lato, sans-serif',
  body: 'Lato, sans-serif',
  mono: 'Lato, sans-serif'
}
